import './SettingsSnooze.scss'

import React, {Component} from 'react'
import { Button } from 'react-bootstrap'

import { push } from 'react-router-redux'
import SettingsSelect from './SettingsSelect.js'

import {
  SNOOZE
} from 'common/constants'

const SettingsSnooze = ({dispatch, settings, onSelect, onRemove}) => {

  function handleRemove() {
    onRemove(() => dispatch(push({pathname:'/settings'})))
  }

  const existingSnooze = <div className="SettingsSnooze__existing">
    <div className="SettingsSnooze__existing__title">Notifications Paused</div>
    <div className="SettingsSnooze__existing__subtitle">Notifications will resume in: <span className="SettingsSnooze__existing__subtitle SettingsSnooze__existing__subtitle--danger">{ settings.existing_snooze }</span></div>
    <Button bsStyle="danger" onClick={handleRemove}>Remove Snooze</Button>
  </div>

  return (
    <div className="SettingsSnooze">
      { settings.existing_snooze ? existingSnooze : null }
      <div className="Settings__label">Snooze Duration</div>
      <SettingsSelect options={SNOOZE} selected={settings.snooze_category} onClick={onSelect} />
    </div>
  )
}

export default SettingsSnooze
